import { fromJS } from 'immutable';

const SET_APPEARANCE = 'axp-myca-root/SET_APPEARANCE';

const initialState = () => fromJS({
  theme: 'light',
});

const reducer = (state = initialState(), action = {}) => {
  switch (action.type) {
    case SET_APPEARANCE:
      return state.set('theme', action.value);
    default:
      return state;
  }
};

const setAppearance = (value) => ({
  type: SET_APPEARANCE,
  value,
});

export default reducer;

export {
  SET_APPEARANCE,
  setAppearance,
};
